import Blue from "~/core";

new Blue({
	name: 'Cookie Acknowledgement',
	selector: ".cookies",
	setup(cookies) {
		const cookiesClose = cookies.querySelector('.cookies__close');
		const acceptButton = cookies.querySelector('.cookies__accept')
		const dismissedKey = 'fccu-cookiesAccepted';

		if(this.$getCookie(dismissedKey)) {
			if(this.$browser.name === 'ie') {
				cookies.style.display = 'none';
			} else {
				cookies.remove();
			}
		}


		const acceptCookies = () => {
			this.$setCookie(dismissedKey, true, 8);
			if(this.$browser.name === 'ie') {
				cookies.style.display = 'none';
			} else {
				cookies.remove();
			}
		}

		this.$addEvents(acceptButton, 'click.prevent', acceptCookies);
		this.$addEvents(cookiesClose, 'click.prevent', acceptCookies);
	}
});